
const PrivacyPolicy = () => (
  <div style={{ padding: '2rem', lineHeight: 1.6 }}>
    <h1>プライバシーポリシー</h1>
    <p>最終更新日：2026年11月4日</p>

    <p>
      CDI CO., LTD.（以下「当社」といいます。）は、
      FITEASY向け機器管理システム「ランチャー」
      （以下「本システム」といいます。）において
      取り扱う個人情報の重要性を認識し、
      個人情報の保護に関する法令を遵守するとともに、
      適切な管理と保護に努めます。
    </p>
    <p>
      本プライバシーポリシーは、本システムにおける
      情報の取得、利用目的、管理および保護に関する
      基本方針を定めるものです。
    </p>

    <h2>第1条（適用範囲）</h2>
    <p>
      本ポリシーは、当社が提供する本システムを
      利用するユーザーの個人情報の取扱いに適用されます。
    </p>

    <h2>第2条（取得・取扱情報）</h2>
    <p>
      当社は、本システムの提供および運用に必要な範囲で、
      以下の情報を取り扱う場合があります。
    </p>
    <ol>
      <li>
        ログインに使用するメールアドレスなどのアカウント情報
      </li>
      <li>
        ユーザーの認証情報およびアクセス履歴
      </li>
      <li>
        システムの操作履歴や利用状況に関する情報
      </li>
      <li>
        登録機器の識別情報、IPアドレス、
        接続状態および稼働状況
      </li>
      <li>
        その他、本システムの運用・保守に必要な情報
      </li>
    </ol>
    <p>
      なお、機器に関する情報については、
      個人を識別できる情報と関連付けられる場合に、
      個人情報として適切に取り扱います。
    </p>

    <h2>第3条（情報の利用目的）</h2>
    <p>
      当社は、取得した情報を以下の目的で利用します。
    </p>
    <ol>
      <li>
        本システムへのログイン認証および利用者の識別
      </li>
      <li>
        登録機器の管理、状態監視および保守業務
      </li>
      <li>
        システム障害や不具合の調査および対応
      </li>
      <li>
        不正アクセスの防止およびセキュリティの確保
      </li>
      <li>
        本システムの安定稼働およびサービス品質の維持・改善
      </li>
      <li>
        利用者からのお問い合わせへの対応
      </li>
    </ol>
    <p>
      取得した個人情報は、法令により認められる場合を除き、
      上記の利用目的の範囲内で取り扱います。
    </p>

    <h2>第4条（個人情報の管理）</h2>
    <p>
      当社は、個人情報への不正アクセス、漏えい、
      紛失、改ざんなどを防止するため、
      必要かつ適切な安全管理措置を講じます。
    </p>
    <p>
      また、個人情報を取り扱う担当者を適切に管理し、
      情報の安全な取扱いに努めます。
    </p>

    <h2>第5条（第三者への提供）</h2>
    <p>
      当社は、法令に基づく場合など、
      法令で認められる場合を除き、
      本人の同意なく個人データを第三者へ提供しません。
    </p>
    <p>
      本システムの運用・保守に必要な業務を
      外部へ委託する場合は、委託先に対して
      必要かつ適切な監督を行います。
    </p>

    <h2>第6条（情報の保存・削除）</h2>
    <p>
      当社は、取得した情報を利用目的の達成に必要な期間、
      または法令や運用上必要な期間において
      適切に管理します。
    </p>
    <p>
      保存の必要がなくなった個人情報については、
      法令その他の必要性を考慮したうえで、
      適切な方法により削除または廃棄します。
    </p>

    <h2>第7条（情報の開示・訂正・削除等）</h2>
    <p>
      利用者本人から、当社が保有する個人情報について、
      開示、訂正、削除または利用停止等の請求があった場合は、
      本人確認を行ったうえで、
      適用される法令に従って適切に対応します。
    </p>

    <h2>第8条（セキュリティ対策）</h2>
    <p>
      本システムでは、利用者の認証、
      アクセス権限の管理、通信の保護など、
      情報の安全性を確保するために必要な対策を実施します。
    </p>
    <p>
      また、システムの運用状況に応じて、
      セキュリティ対策の継続的な見直しに努めます。
    </p>

    <h2>第9条（プライバシーポリシーの変更）</h2>
    <p>
      当社は、法令の変更、システムの機能変更、
      運用方針の見直しなどに応じて、
      本ポリシーを変更することがあります。
    </p>
    <p>
      変更する場合は、本システム上での掲示その他
      適切な方法により周知します。
    </p>

    <h2>第10条（お問い合わせ）</h2>
    <p>
      本システムにおける個人情報の取扱い、
      開示・訂正・削除等の請求、
      その他プライバシーに関するお問い合わせは、
      本システムの運用担当者までご連絡ください。
    </p>
    <p>
      お問い合わせ内容に応じて、
      当社が適切に対応いたします。
    </p>

    <p style={{ marginTop: '2rem' }}>
      CDI CO., LTD.
    </p>
  </div>
);

export default PrivacyPolicy;
